import { Campaign, GetAllCampaignsResponse, GetCampaignResponse } from "@/types/campaign";
import { api } from "@/integrations/clients/carAuction/carAuctionClient";


export class CampaignService {
  static async getAllCampaigns(page: number = 1, limit: number = 10): Promise<GetAllCampaignsResponse> {
      const response = await api.get<GetAllCampaignsResponse>(`/campaigns?page=${page}&limit=${limit}`);
      return response;
  }


  // Get a specific campaign with all its listings
  static async getCampaign(campaignId: string, listingsPage: number = 1, listingsLimit: number = 30): Promise<GetCampaignResponse> {

    const response = await api.get<GetCampaignResponse>(`/campaigns/${campaignId}?listingsPage=${listingsPage}&listingsLimit=${listingsLimit}`);
    return response;
  }

  static async getPublicCampaign(
    campaignId: string,
    listingsPage: number = 1,
    listingsLimit: number = 30,
  ): Promise<{
    campaign: {
      id: string;
      name: string;
      description: string;
      startDate: string;
      endDate: string;
      status: string;
      type: string;
      totalListings: number;
    };
    listings: import("@/types/listing").ListingOverview[];
    totalListings: number;
    isGuestView: boolean;
  }> {
    const response = await api.get<{
      campaign: {
        id: string;
        name: string;
        description: string;
        startDate: string;
        endDate: string;
        status: string;
        type: string;
        totalListings: number;
      };
      listings: import("@/types/listing").ListingOverview[];
      totalListings: number;
      isGuestView: boolean;
    }>(
      `/campaigns/public/${campaignId}?listingsPage=${listingsPage}&listingsLimit=${listingsLimit}`,
    );
    return response;
  }

  // Get public auction campaigns (unprotected endpoint)
  static async getPublicAuctionCampaigns(limit: number = 10): Promise<Array<{
    id: string;
    name: string;
    description: string;
    thumbnailUrl: string;
    totalListings: number;
    timeLeft: string;
    type: 'auction' | 'direct-purchase';
    status: 'active' | 'upcoming' | 'completed' | 'cancelled';
    labels?: Array<{
      labelType: 'reduced_percentage' | 'reduced_amount' | 'special';
      text: string;
    }>;
  }>> {
    const response = await api.get<{ success: boolean; data: Array<{
      id: string;
      name: string;
      description: string;
      thumbnailUrl: string;
      listingsCount: number;
      timeLeft: string;
      type: 'auction' | 'direct-purchase';
      status: 'active' | 'upcoming' | 'completed' | 'cancelled';
      labels?: Array<{
        labelType: 'reduced_percentage' | 'reduced_amount' | 'special';
        text: string;
      }>;
    }> }>(`/campaigns/public/auctions?limit=${limit}`);
    // Map listingsCount to totalListings for consistency with Campaign type
    return (response.data || []).map(c => ({
      ...c,
      totalListings: c.listingsCount,
      type: c.type || 'auction',
      status: c.status || 'upcoming',
      labels: c.labels || [],
    }));
  }
}